import $ from 'jquery';

const video_launcher = $('.yt-launcher, .vimeo-launcher');

if (video_launcher.length) {
  $(document).on('click', '.yt-launcher, .vimeo-launcher', function () {
    const $container = $(this);

    const overlay = $container.find('.video-overlay-title');
    const iframe  = $container.find('iframe');
    const img     = $container.find('img');

    const srcUrl = iframe.data('src') + '?rel=0&controls=1&showinfo=0&autoplay=1&mute=1';

    iframe.attr('src', srcUrl);
    overlay.hide();
    img.hide();
    iframe.addClass('show');
  });
}
